export const defaultHeight = 450;
export const defaultBottomSpacing = 15;
export const defaultTopSpacing = 10;
